<template>
  <div class="pm-dialog-team-leader">
    <vs-tabs v-model="activeTab" alignment="center" color='#2d9cdb'>
      <vs-tab v-for="(rank, index) in rankList" :key="index" :label="rank.value" color='#2d9cdb'>
        <div class="flex justify-center outer-area">
          <div class="vs-row w-full">
            <div v-for="(master,index) in masterList" :key="index" >
              <div class="candidate-list vs-col w-1/6" v-if="master.rank == rank.id " >
                <vs-button
                  :color="itemColor(master.id)"
                  :transparent="itemTransparent(master.id)"
                  :class="[ itemTransparent(master.id) ? 'pm-chip-with-border' : 'pm-chip-without-border' ]"
                  @mousedown="onClick(master.id)"
                >
                  {{ master.short_name || master.name }}
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      activeTab: 0,
      selectedData: {},
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      let masterList = this.masterMap['team_leader'];
      return masterList;
    },
    enableSave() {
      return true; // ( this.selectedData !== {} );
    },
    rankList() {
      let masterList = this.masterMap['rank'];
      return masterList;
    },
  },
  methods: {
    initData() {
      this.selectedData = this.valueMap ? { id: this.valueMap.id  ,status: this.valueMap.status } : {};
      this.activeTab = 0;
      this.$nextTick(() => {
        const selectedData = this.masterList.find(x => x.id === this.selectedData.id);
        if (selectedData) {
          this.rankList.forEach((rank, index) => {
            if ( selectedData.rank && selectedData.rank == rank.id ) {
              this.activeTab = index;
            }
          });
        }
      });
    },
    getTeamLeaderListByRank(rankId) {
      return this.masterList.filter(teamLeader => teamLeader.rank == rankId);
    },
    itemColor(masterId) {
      let itemColorCode = '#828282';
      if ( masterId === this.selectedData.id ) {
         if ( this.selectedData.status === 2 ) {
           itemColorCode = '#081e29';
         } else if (this.selectedData.status === 3 ) {
           itemColorCode = '#21526d';
         }
      }
      return itemColorCode;
    },
    itemTransparent(masterId) {
      let isTransparent = false;
      if ( masterId === this.selectedData.id ) {
         if ( this.selectedData.status === 2 ) {
           isTransparent = true;
         }
      }
      return isTransparent;
    },
    onClick(clickId) {
      if (this.selectedData.id === clickId ) {
        this.selectedData.status = ( this.selectedData.status % 3 ) + 1;
        if ( this.selectedData.status === 2 ) { this.selectedData.status = 3; } // 予約状態は存在しない。 
      } else {
        this.selectedData = {
          id: this.masterList.find(master => master.id === clickId).id,
          status: 3,
        };
      }
    },
    changeSearchInput() {
      this.selectedId = -1
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = ["update"];
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey + '#id'] = {};
      if (this.selectedData.id) updateKeyValueMap[this.columnKey + '#id'][this.selectedData.id] = this.selectedData.status;
      this.$emit('updateValue', this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";

.pm-dialog-team-leader {
  .outer-area {
    padding: 1rem;
    max-height: 19rem;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .candidate-list {
    margin: 0rem;
    min-height: 3.2rem;
  }
  .vs-tabs--btn {
    min-height: 3rem;
    color: $pm-dark-gray;
    border: 1px solid $pm-navy;
    border-radius: 2px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    :hover {
      color: $pm-black;
    }
  }
  .activeChild button.vs-tabs--btn {
    background-color:$pm-navy !important;
    span {
      color: $pm-white;

    }
  }
  .vs-tabs--li {
    margin: 0 0.1rem;
  }
  .vs-tabs--ul {
    border-bottom: 4px solid $pm-navy;
  }
  .con-slot-tabs {
    div {
      transition: unset;
    }
  }
  .pm-chip-with-border {
    width: 96%;
    white-space: nowrap;
    overflow: hidden;
    border:1px solid $pm-navy;
  }
  .pm-chip-without-border {
    width: 96%;
    white-space: nowrap;
    overflow: hidden;
    border:none;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

